import React from 'react';
import { LinearProgress } from '@material-ui/core';

import PxwQuantityInputs from './PxwQuantityInputs';
import PxwDropdownSelectors from './PxwDropdownSelectors';

import { usePxwSelectionForm } from './usePxwSelectionForm';

import { IPxwSelectionFormProps } from '../../views/PxwProcessDevices/types';

const PxwSelectionForm: React.FC<IPxwSelectionFormProps> = ({
  selectedTenant,
  isLoading,
  onSynthesize,
  onResultInvalidated,
}) => {
  const {
    formOptions,
    formInputs,
    totalQty,
    receivedQty,
    updateQty,
    isSubmitDisabled,
    showValidationHint,
    handleTestProviderChange,
    handlePOChange,
    handleItemChange,
    handleSubmit,
  } = usePxwSelectionForm(selectedTenant, isLoading, onSynthesize, onResultInvalidated);

  if (formOptions.isLoading) {
    return (
      <div className="cell margin-top-1 margin-bottom-2 small-12 medium-6">
        <LinearProgress />
      </div>
    );
  }

  return (
    <>
      <PxwDropdownSelectors
        selectedTenant={selectedTenant}
        formInputs={formInputs}
        formOptions={formOptions}
        onTestProviderChange={handleTestProviderChange}
        onPOChange={handlePOChange}
        onItemChange={handleItemChange}
      />
      <PxwQuantityInputs
        totalQty={totalQty}
        receivedQty={receivedQty}
        formInputs={formInputs}
        isSubmitDisabled={isSubmitDisabled}
        showValidationHint={showValidationHint}
        onMatchChange={(v) => updateQty({ matchQty: v })}
        onMismatchFunctionalChange={(v) => updateQty({ mismatchFunctionalQty: v })}
        onMismatchNonFunctionalChange={(v) => updateQty({ mismatchNonFunctionalQty: v })}
        onSubmit={handleSubmit}
      />
    </>
  );
};

export default PxwSelectionForm;
